var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{staticClass:"d-flex"},[_c('Sidebar'),_c('b-container',{attrs:{"fluid":""}},[_c('b-overlay',{attrs:{"show":_vm.loading,"variant":"light"}},[(!_vm.loading)?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }